import { type FC } from "react";

import { useMutation } from "@apollo/client/react";

import { type Conversation, ConversationDestroyDocument } from "@app_schema";

import { DestroyDialog } from "@styled/destroy_dialog";

import { ConversationName } from "./conversation_name";

export const ConversationDestroyDialog: FC<{
  conversation: Pick<Conversation, "id"> & {
    agent: Pick<Conversation["agent"], "id" | "name">;
  };
  onDestroy?(): void;
  onClose(): void;
}> = ({ conversation, onDestroy, onClose }) => {
  const [execute, { loading }] = useMutation(ConversationDestroyDocument);

  const onConfirm = async () => {
    await execute({ variables: { id: conversation.id } });
    onDestroy?.();
  };

  return (
    <DestroyDialog
      name={<ConversationName conversation={conversation} />}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
    >
      Deleting “<ConversationName conversation={conversation} />” also deletes
      any attached artifacts or messages.
    </DestroyDialog>
  );
};
